export default {
  origin: null,
  origins: null,
  originSelected: null,
};
